import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SecondLobePiercingImage from '../../Assets/ImgAi/secondlobepiercingai2.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SecondLobePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Second Lobe Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Second Lobe Piercing Dubai, UAE with precise placement, high-quality jewellery and professional care at a trusted studio. "
            />
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Second Lobe Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Second Lobe Piercing 100-150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SecondLobePiercingImage} alt="Second Lobe Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Second Lobe Piercing</h3>

          <p>
            Upgrade your style with our professional second lobe piercing services in the UAE, available at an affordable price range of 100–125 AED. A second lobe piercing is a chic and trendy way to enhance your look by adding an additional hole to your ear lobe, allowing you to mix and match earrings for a more stylish and personalized appearance. Whether you want a subtle double stud look or a bold layered style, our expert specialists ensure precise placement that perfectly complements your existing piercing and overall aesthetic.
          </p>

          <p>
            We are committed to providing safe and hygienic ear piercing services using sterile, single-use, high-quality equipment. Our certified professionals follow strict hygiene protocols to ensure a clean and infection-free experience. Each second lobe piercing is performed with accuracy and care, minimizing discomfort and ensuring a smooth procedure. Our goal is to make your experience quick, comfortable, and stress-free, whether you are getting your second piercing for the first time or upgrading your current ear styling.
          </p>

          <p>
            Second lobe piercing is suitable for both teens and adults who want to elevate their ear jewelry game with a modern and fashionable touch. The procedure is simple and usually completed within minutes, making it a convenient option for those with busy schedules. Our specialists are trained in advanced techniques that help reduce pain and promote faster healing, ensuring you can enjoy your new piercing without unnecessary discomfort. We also offer hypoallergenic starter earrings designed for sensitive skin, helping to prevent irritation and ensuring a safe healing process.
          </p>

          <p>
            Our clean and welcoming environment is designed to make you feel relaxed and confident throughout your visit. We understand that every client has unique preferences, so we provide personalized consultation to help you choose the ideal placement for your second lobe piercing. Whether you prefer a close, minimal gap or a slightly spaced design for stacking multiple earrings, we ensure the result matches your desired look perfectly.
          </p>

          <p>
            Aftercare is an essential part of maintaining your new piercing, and our team provides detailed guidance to help you care for your ears properly. We explain the best cleaning practices, recommended products, and tips to avoid infections or irritation during the healing period. With proper care, your second lobe piercing will heal quickly and remain a stylish addition to your overall appearance.
          </p>

          <p>
            Our second lobe piercing services in the UAE combine affordability with premium quality, ensuring you receive excellent value without compromising on safety or professionalism. We offer transparent pricing with no hidden charges, and our easy booking system allows you to schedule your appointment at your convenience. With minimal waiting time and efficient service, we ensure a hassle-free experience from start to finish.
          </p>

          <p>
            Choose our trusted second lobe piercing services in the UAE for a safe, stylish, and professional experience. With skilled specialists, hygienic procedures, and a focus on customer satisfaction, we help you achieve a trendy and elegant look effortlessly. Book your second lobe piercing appointment today and take your ear styling to the next level with confidence and ease.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Second lobe Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SecondLobePiercing;